// extracted by mini-css-extract-plugin
export default {"container":"table-row_container__iEdiV","label":"table-row_label__9avbp","result":"table-row_result__RNQMc"};